import { $, $$, on, lockScroll, unlockScroll } from './core/dom.js';

/** Fast navigation: skygge/komprimering ved scroll */
function initScrollState() {
  const nav = $('.nav');
  if (!nav) return;
  const update = () => nav.classList.toggle('is-scrolled', window.scrollY > 60);
  on(window, 'scroll', update, { passive: true });
  update();
}

/** Burgermenu + mobil-drawer */
function initDrawer() {
  const burger = $('.nav__burger');
  const drawer = $('.drawer');
  if (!burger || !drawer) return;

  const close = () => {
    drawer.classList.remove('is-open');
    burger.classList.remove('is-open');
    burger.setAttribute('aria-expanded', 'false');
    unlockScroll();
  };

  on(burger, 'click', () => {
    const open = drawer.classList.toggle('is-open');
    burger.classList.toggle('is-open', open);
    burger.setAttribute('aria-expanded', String(open));
    open ? lockScroll() : unlockScroll();
  });

  // Luk ved klik på et menupunkt
  $$('.drawer a, .drawer__gen', drawer).forEach(el => on(el, 'click', close));

  // Udvid/fold undermenuer
  $$('.drawer__item--has-sub .drawer__link', drawer).forEach(link =>
    on(link, 'click', e => {
      e.preventDefault();
      link.closest('.drawer__item').classList.toggle('is-open');
    })
  );

  on(document, 'keydown', e => { if (e.key === 'Escape') close(); });

  return { close };
}

export function initNavigation() {
  initScrollState();
  return initDrawer();
}
